<template>
  <v-card width="1000px" class="mx-auto"
    ><v-card-title class="d-flex flex-column"
      ><h1>{{ $t("maintain.title") }}</h1></v-card-title
    ><v-card-text class="text-center"
      ><div class="ctext pb-3">
        <div v-if="priv == 80">{{ $t("maintain.basic_info") }}</div>
        <div v-else-if="priv == 85">{{ $t("maintain.basic_info_x") }}</div>
      </div></v-card-text
    ></v-card
  >
</template>
<script>
export default {
  name: "maintain_and_leave",
  computed: {
    priv() {
      return this.$store.state.user.surrogated_student_info.payload.ticket
        .privilege;
    },
  },
};
</script>
<style scoped>
.ctext {
  font-size: 18px;
  color: black;
}
</style>
